var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBonusWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 24.375l.669-.753L30 7.5 24.375 0H5.625L0 7.5l14.331 16.122.669.753zm1.328-3L28.218 8h-5.405l-6.485 13.376zM24.287 1.55L28.375 7h-5.256l1.168-5.451zM21.169 7L15 1.602 8.83 7h12.34zm1.02-.436L23.381 1h-7.55l6.358 5.564zM14.17 1L7.811 6.564 6.618 1h7.551zM15 21.823L8.298 8h13.404L15 21.823zm-1.328-.447L7.187 8H1.782l11.89 13.376zM5.713 1.549L6.882 7H1.625l4.088-5.451z",
    fill: "#fff"
  })));
}
SvgBonusWhite.displayName = 'BonusWhite';
export default SvgBonusWhite;